"use client";
import React, { useRef, useState } from "react";
import { useRouter } from "next/navigation";
import { sendFormEvent } from "@/app/_ga4/eventHandler";

export default function SerialLookupForm() {
  const serialRef = useRef(null);
  const [serialStatusAlert, setSerialStatusAlert] = useState("");
  const [formStarted, setFormStarted] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const router = useRouter();

  const validateSerial = async (serial) => {
    if (!serial) {
      return false;
    }
    let response = await fetch(`/api/getSerial`, {
      method: "POST",
      body: serial,
    });
    response = await response.json();
    return response;
  };

  const handleFormStart = () => {
    if (!formStarted) {
      setFormStarted(true);
      sendFormEvent("SERIAL_SEARCH", "START");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisabled(true);
    const serialNumber = serialRef.current.value;
    let serialStatus = await validateSerial(serialNumber);
    sendFormEvent("SERIAL_SEARCH", "SUBMIT");
    if (!serialStatus.status) {
      setSerialStatusAlert(
        serialStatus.data ||
          "Invalid serial number, please re-enter a valid serial serial number"
      );
      sendFormEvent("SERIAL_SEARCH", "INVALID/ERROR");
      setDisabled(false);
      return;
    } else {
      sendFormEvent("SERIAL_SEARCH", "SUCCESS");
      setFormStarted(false);
      setSerialStatusAlert("");
      setDisabled(false);
      router.push(`/serial-results/${serialNumber}`);
    }
  };

  return (
    <div>
      <div>
        <h2>Serial Number Search</h2>
        <p>
          We aim to guarantee your complete confidence in using our floor
          cleaning equipment and other machines. If you require further
          assistance beyond the resources we have already provided, please feel
          free to reach out to us.
        </p>
        <form className="request-demo-form" onSubmit={handleSubmit}>
          <div className="form-section">
            <div className="input-group">
              <p className="error">{serialStatusAlert}</p>
              <label>Serial Number</label>
              <input
                type="text"
                id="serial"
                name="serial"
                placeholder="Enter Serial Number"
                ref={serialRef}
                onFocus={handleFormStart} // Add this line to detect form start
              />
            </div>
          </div>
          <div className="input-group"></div>
          <div className="form-group">
            <button className="cta-button" type="submit" disabled={disabled}>
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
